import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBasketLoading } from 'features/basket';
import { analyticsUtils } from 'utils';
import { yandexSplitContainer, yandexSplitWidget, hidden } from './styles';
import { YandexSplitBannerSkeleton } from './yandex-split-banner-skeleton';
import { useYandexPayWidget } from './hooks/use-yandex-pay-widget';
import { getVisibilityBanner } from './utils';
import { getIsBot } from 'common/selectors';
import { getCurrency, getDivisionId, getSource } from 'features/product-info';
import { YaSplitInfo } from 'types/page-model';
import { getYandexSplitSession } from './selectors';
import { RESET_YANDEX_SPLIT_SESSION } from './reducer';

export const DATA_QA_YANDEXSPLIT = 'yandexsplit_mf-pdp';

type Props = {
  yaSplitInfo: YaSplitInfo;
  price?: number | null;
  isSet?: boolean;
  quantity: number;
};

export const YandexSplitBanner: React.FC<Props> = ({ yaSplitInfo, price, isSet, quantity }) => {
  const dispatch = useDispatch();
  const isSentAnalytics = useRef(false);

  const isBot = useSelector(getIsBot);
  const currentDivision = String(useSelector(getDivisionId));
  const currentSource = useSelector(getSource)?.toLowerCase();
  const currency = useSelector(getCurrency) || 'RUB';
  const isBasketLoading = useSelector(getBasketLoading);
  const session = useSelector(getYandexSplitSession);

  const shouldShowBanner = getVisibilityBanner({
    isBot,
    enabled: yaSplitInfo.enabled,
    price,
    maxPriceThreshold: yaSplitInfo.maxPriceThreshold,
    KindDivisionsList: yaSplitInfo.KindDivisionsList,
    currentDivision,
    KindSourceList: yaSplitInfo.KindSourceList,
    currentSource,
  });

  if (shouldShowBanner && !isSentAnalytics.current) {
    analyticsUtils.sendEvent('GA:show', {
      elementName: 'Яндекс.Сплит',
      elementText: 'Оплата частями',
      elementType: 'banner',
      elementBlock: isSet ? 'komplektyDetail' : 'productDetail',
    });
    isSentAnalytics.current = true;
  }

  const widgetRef = useYandexPayWidget({
    currency,
    isBasketLoading,
    price,
    quantity,
    yaSplitInfo,
  });

  useEffect(() => {
    return () => {
      dispatch(RESET_YANDEX_SPLIT_SESSION());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!shouldShowBanner) return null;

  return (
    <div className={yandexSplitContainer} data-qa={DATA_QA_YANDEXSPLIT}>
      <div className={session ? yandexSplitWidget : hidden}>
        <div ref={widgetRef} />
      </div>
      <YandexSplitBannerSkeleton />
    </div>
  );
};
